var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCad(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "transfer owner") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "transfer-owner",
    fillRule: "nonzero",
    fill: "#58595B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1,2.5 C1,1.791 2.027,1 3.5,1 C4.973,1 6,1.791 6,2.5 C6,3.209 4.973,4 3.5,4 C2.027,4 1,3.209 1,2.5 M7,2.5 C7,1.119 5.433,0 3.5,0 C1.567,0 0,1.119 0,2.5 C0,3.758 1.306,4.789 3,4.964 L3,14 L4,14 L4,13 L5,13 L5,12 L4,12 L4,11 L6,11 L6,10 L4,10 L4,4.964 C5.694,4.789 7,3.758 7,2.5",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "10.816 5.728 12.085 6.997 6 6.997 6 7.996 12.087 7.996 10.814 9.27 11.511 9.986 14 7.498 11.503 5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCad);
export default __webpack_public_path__ + "static/media/cad.b339d1e3ff43801c7d326b468d172311.svg";
export { ForwardRef as ReactComponent };